import { render } from "./opportunities.page.vue?vue&type=template&id=3783d823&ts=true"
import script from "./opportunities.page.vue?vue&type=script&lang=ts"
export * from "./opportunities.page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__